import { Plugin } from '@nuxt/types'
import WebSocketService from '@/services/WebSocketService'

// 本プロジェクトで利用するグローバルウェブソケットは全て一つのインスタンスを元に処理を行う
export const GlobalWebSocketService = new WebSocketService()

declare module 'vue/types/vue' {
  interface Vue {
    $webSocket: WebSocketService
  }
}

declare module '@nuxt/vue-app' {
  interface NuxtAppOptions {
    $webSocket: WebSocketService
  }
}

const plugin: Plugin = (context, inject) => {
  inject('webSocket', GlobalWebSocketService)
}

export default plugin
